// Libs
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { NavDropdown } from 'react-bootstrap';
import { Nav, Navbar } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService       from 'services/GlobalStateService';
import DOMHelpers               from 'helpers/DOMHelpers';
import BootboxHelper            from 'helpers/BootboxHelper';
import LocationService          from 'services/LocationService';
import ContractService         from 'services/ContractService';
                                
// Components                   
import SearchBox                from 'components/common/SearchBox';
import EditBookingModal         from 'components/bookings/EditBookingModal';
import InstructorCredentialsEmailsModal   from 'components/admin/InstructorCredentialsEmailsModal';
import SubmitEnquiryModal       from 'components/SubmitEnquiryModal';
import SubmitSupportTicketModal from 'components/support/SubmitSupportTicketModal';
import EmergencyModal           from 'components/support/EmergencyModal';
import EditJobRequestModal from 'components/admin/job-request/EditJobRequestModal';

// Images
import logoImage from 'images/flip-logo-white.png';

//-------------------------------------------------------------------------------------------------------------------

class TopNav extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();
        this.dataQualityEmailsModalRef = React.createRef();
        this.submitEnquiryModal = React.createRef();
        this.submitSupportTicketModal = React.createRef();
        this.emergencyModal = React.createRef();
        this.classSearchModalRef = React.createRef();

        this.state = {
            showMenu: false,
            isExpanded: false,
            geos: []
        };

        GlobalStateService.subscribe('area', (area) => {
            this.setState({ area });
        });
    }

    async componentDidMount() {
        // Get list of geos
        const geos = await LocationService.listGeos();
        geos.sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0)); // Put default first
        this.setState({ geos });

        // Get latest contract
        const loginInfo = GlobalStateService.getValue('loginInfo');
        if (loginInfo && loginInfo.isInstructorOrManager) {
            const contract = await ContractService.getLatest();
            this.setState({ contract });

            // Nag them to sign the contract
            if (contract && contract.dateLinkSent && !contract.dateSigned && loginInfo.instructor) {
                const area = GlobalStateService.getValue('area');
                if (area != 'sign-contract') {
                    BootboxHelper.alert('There is a new contract available for you to sign. Please click \'Sign Contract\' on the top menu at your earliest convenience.');
                }
            }
        }
    }

    onClickNav(e, preventDefault) {
        DOMHelpers.scrollToMiddle(e.target)
        this.setState({ isExpanded: false });
        if (preventDefault) {
            e.preventDefault();
        }
    }

    async confirmLogOut() {
        const confirm = await BootboxHelper.confirm('Are you sure you want to log out?');
        if (confirm) {
            const logOutMethod = GlobalStateService.getValue('logOut');
            logOutMethod();
        }
    }

    async switchInstructor(id) {
        const method = GlobalStateService.getValue('switchInstructor');
        method(id);
    }

    selectSearchResult(item) {
        const id = item.id.split('-')[1];
        switch (item.type) {
            case 'booking':
                this.editBookingModalRef.current.show({
                    bookingID: id
                });
                break;
            case 'instructor':
                this.props.history.push(`/${item.status == 'Candidate' ? 'candidate' : 'instructor'}/${item.slug}`);
                break;
            case 'subagency':
                this.props.history.push(`/sub-agency/${item.slug}`);
                break;
        }
    }

    showInstructorCredentialsEmailsModal() {
        this.dataQualityEmailsModalRef.current.show({

        });
    }

    showSubmitEnquiryModal() {
        this.submitEnquiryModal.current.show({

        });
    }

    showSubmitSupportTicketModal() {
        this.submitSupportTicketModal.current.show({ });
    }

    showEmergencyModal() {
        this.emergencyModal.current.show({ });
    }

    async showClassSearchModal() {
        await this.classSearchModalRef.current.show({
            type: 'VendorClassSearch'
        });
    }

    //------------------------------------------------------------------------------------------------------------------------

    render() {
        const { hideMenu } = this.props;
        const { isExpanded } = this.state;
        
        return (<>
            <Navbar expanded={isExpanded} expand="md" bg="dark" variant="dark" sticky="top" className={'top-nav ' + (hideMenu ? 'hide-menu' : '')}>
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <img src={logoImage} />
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={() => this.setState({ isExpanded: !isExpanded })} />
                    <Navbar.Collapse className="flex-md-column">
                        {hideMenu ? this.renderSimpleMainMenu() : this.renderMainMenu()}
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <EditBookingModal ref={this.editBookingModalRef} />
            <InstructorCredentialsEmailsModal ref={this.dataQualityEmailsModalRef} />
            <SubmitEnquiryModal ref={this.submitEnquiryModal} />
            <SubmitSupportTicketModal ref={this.submitSupportTicketModal} />
            <EmergencyModal ref={this.emergencyModal} />
            <EditJobRequestModal ref={this.classSearchModalRef} />

        </>);
    }

    renderMainMenu() {
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const area = GlobalStateService.getValue('area') || '';
        const { contract } = this.state;

        return (<>

            <Nav className="ms-auto">

                {loginInfo.isAdmin &&
                    <SearchBox
                        types={[ 'Instructor', 'Booking', 'SubAgency' ]}
                        onSelect={item => this.selectSearchResult(item)}
                    />
                }

                {/* VENDOR / ADMIN ONLY */ }

                {loginInfo.isVendorOrAdmin && <>

                    <NavDropdown title="Instructors" active={area.indexOf('instructors-') == 0 || area == 'sub-agencies' || area == 'enablement' || area == 'map'}>
                        <NavDropdown.Item as={Link} active={area == 'instructors-prospect'} to="/instructors/Prospect" onClick={e => this.onClickNav(e)}>
                            Prospects
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} active={area == 'instructors-candidate'} to="/instructors/Candidate" onClick={e => this.onClickNav(e)}>
                            Candidates
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} active={area == 'instructors-approved'} to="/instructors/Approved" onClick={e => this.onClickNav(e)}>
                            Approved Instructors
                        </NavDropdown.Item>
                        {loginInfo.isAdmin && <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} active={area == 'sub-agencies'} to="/sub-agencies" onClick={e => this.onClickNav(e)}>
                                Sub-agencies
                            </NavDropdown.Item>
                        </>}
                        <NavDropdown.Divider />
                        <NavDropdown.Item as={Link} active={area == 'enablement'} to="/enablement" onClick={e => this.onClickNav(e)}>
                            Enablement
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} active={area == 'map'} to="/map" onClick={e => this.onClickNav(e)}>
                            Map
                        </NavDropdown.Item>
                        {loginInfo.isVendor && <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="#" onClick={e => {
                                e.preventDefault();
                                this.onClickNav(e);
                                this.showClassSearchModal();
                            }}>
                                Class search
                            </NavDropdown.Item>
                        </>}
                    </NavDropdown>

                </>}

                {/* VENDOR / ACCOUNTANT / ADMIN ONLY */}

                {loginInfo.isVendorOrAccountantOrAdmin &&
                    <Nav.Item>
                        <Nav.Link as={Link} to="/bookings" active={area.indexOf('bookings') == 0} onClick={e => this.onClickNav(e)}>
                            Bookings
                        </Nav.Link>
                    </Nav.Item>
                }

                {/* INSTRUCTOR / MANAGER */}

                {loginInfo.isInstructorOrManager && loginInfo.instructor && <>
                    {contract && contract.dateLinkSent && !contract.dateSigned &&
                        <Nav.Item>
                            <Nav.Link as={Link} to="/sign-contract" active={area == 'sign-contract'} onClick={e => this.onClickNav(e)} className="sign-contract">
                                <span className="fa fa-triangle-exclamation" />{' '}
                                Sign Contract
                            </Nav.Link>
                        </Nav.Item>
                    }
                    {loginInfo.isInstructor && loginInfo.site.enableEmergency &&
                        <Nav.Item>
                            <Nav.Link as={Link} to="#" onClick={e => {
                                this.showEmergencyModal();
                                this.onClickNav(e);
                            }}>
                                <span className="fa fa-triangle-exclamation" />{' '}
                                Urgent booking issue
                            </Nav.Link>
                        </Nav.Item>
                    }
                    <Nav.Item>
                        <Nav.Link as={Link} to={'/instructor/' + loginInfo.instructor.slug} active={area == 'instructors' || area == 'candidates'} onClick={e => this.onClickNav(e)}>
                            {loginInfo.isInstructor ? 'My ' : 'Edit '} Profile
                        </Nav.Link>
                    </Nav.Item>
                    {loginInfo.instructor.type != 'Candidate' && <>
                        <Nav.Item>
                            <Nav.Link as={Link} to="/availability-selector" active={area == 'availability-selector'} onClick={e => this.onClickNav(e)}>
                                {loginInfo.isInstructor ? 'My ' : 'Edit '} Availability
                            </Nav.Link>
                        </Nav.Item>
                        {loginInfo.canInvoice &&
                            <Nav.Item>
                                <Nav.Link as={Link} to="/invoicing/my-invoices" active={area == 'invoicing'} onClick={e => this.onClickNav(e)}>
                                    Invoicing
                                </Nav.Link>
                            </Nav.Item>
                        }
                    </>}
                    <Nav.Item>
                        <Nav.Link as={Link} to="/help" active={area == 'help'} onClick={e => this.onClickNav(e)}>
                            Help
                        </Nav.Link>
                    </Nav.Item>
                </>}

                {/* ACCOUNTANT / ADMIN */}

                {loginInfo.isAccountantOrAdmin &&
                    <NavDropdown title="Invoicing" active={area == 'invoicing'}>
                        <NavDropdown.Item as={Link} to="/invoicing/invoices" active={area == 'invoicing-invoices'} onClick={e => this.onClickNav(e)}>
                            Invoices
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/invoicing/bills" active={area == 'invoicing-bills'} onClick={e => this.onClickNav(e)}>
                            Bills
                        </NavDropdown.Item>
                        {/*
                        {loginInfo.isSiteAdmin &&
                            <NavDropdown.Item as="a" href="/api/invoice/get-beneficiaries-file">
                                Beneficiaries file
                            </NavDropdown.Item>
                        }
                        */}
                    </NavDropdown>
                }

                {/* VENDOR / ADMIN ONLY */}

                {loginInfo.isVendorOrAdmin && <>
                    <Nav.Item>
                        <Nav.Link as={Link} active={area == 'calendar'} to="/calendar" onClick={e => this.onClickNav(e)}>
                            Calendar
                        </Nav.Link>
                    </Nav.Item>
                    {loginInfo.site.enableReportsSection &&
                        <Nav.Item>
                            <Nav.Link as={Link} active={area == 'reports'} to="/reports" onClick={e => this.onClickNav(e)}>
                                Reports
                            </Nav.Link>
                        </Nav.Item>
                    }
                </>}

                {/* VENDOR ONLY */}

                {loginInfo.isVendor &&
                    <Nav.Item>
                        <Nav.Link href="#" active={area == 'map'} onClick={e => { this.onClickNav(e, true); this.showSubmitEnquiryModal(); }}>
                            Submit Enquiry
                        </Nav.Link>
                    </Nav.Item>
                }

                {/* ADMIN ONLY */}

                {loginInfo.isAdmin && this.renderAdminDropdown()}

                {/* LOGIN INFO */}
                {this.renderLoginMenu(true)}
                
            </Nav>

        </>);
    }

    renderSimpleMainMenu() {
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const area = GlobalStateService.getValue('area') || '';
        const { contract } = this.state;
        
        return (
            <Nav className="ms-auto">
                {loginInfo.isInstructorOrManager && loginInfo.instructor && <>
                    {contract && contract.dateLinkSent && !contract.dateSigned &&
                        <Nav.Item>
                            <Nav.Link as={Link} to="/sign-contract" active={area == 'sign-contract'} onClick={e => this.onClickNav(e)} className="sign-contract">
                                <span className="fa fa-triangle-exclamation" />{' '}
                                Sign Contract
                            </Nav.Link>
                        </Nav.Item>
                    }
                </>}

                {/* LOGIN INFO */}
                {this.renderLoginMenu(false)}
            </Nav>
        );
    }

    renderLoginMenu(canRequestSupport) {
        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (
            <NavDropdown title={<span className="fa-solid fa-user" />} align="end">
                <NavDropdown.Item as={Link} to="#" onClick={e => this.confirmLogOut()}>
                    <span className="fa-solid fa-right-from-bracket" />{' '}
                    Log out
                </NavDropdown.Item>
                <NavDropdown.Divider />
                {loginInfo.instructors.map(i =>
                    <NavDropdown.Item
                        key={i.id}
                        active={loginInfo.instructor && i.id == loginInfo.instructor.id}
                        onClick={e => this.switchInstructor(i.id)}
                    >
                        {loginInfo.instructor && i.id == loginInfo.instructor.id &&
                            <><span className="fa-solid fa-user" />{' '}</>
                        }
                        {i.firstName} {i.lastName}
                    </NavDropdown.Item>
                )}
                {canRequestSupport && <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item as={Link} to="#" onClick={e => this.showSubmitSupportTicketModal()}>
                        <span className="fa-solid fa-circle-question" />{' '}
                        Request support
                    </NavDropdown.Item>
                </>}
            </NavDropdown>
        );
    }

    renderAdminDropdown() {
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const area = GlobalStateService.getValue('area');
        
        return (
            <NavDropdown title="Admin" align="end" active={area == 'admin'}>
                <NavDropdown.Header>
                    Admin tools
                </NavDropdown.Header>
                <NavDropdown.Item as={Link} to="/todos" active={area == 'todos'} onClick={e => this.onClickNav(e)}>
                    To do list
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/enquiries" active={area == 'enquiries'} onClick={e => this.onClickNav(e)}>
                    Enquiries
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/course-checker" active={area == 'course-checker'} onClick={e => this.onClickNav(e)}>
                    Course checker
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/swap-search" active={area == 'swap-search'} onClick={e => this.onClickNav(e)}>
                    Swap search
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/unbilled-days" active={area == 'unbilled-days'} onClick={e => this.onClickNav(e)}>
                    Unbilled days
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/enablement-compare" active={area == 'enablement-compare'} onClick={e => this.onClickNav(e)}>
                    Enablement compare
                </NavDropdown.Item>
                {/*
                <NavDropdown.Item as={Link} to="/import" active={area == 'import'} onClick={e => this.onClickNav(e)}>
                    Import Bookings
                </NavDropdown.Item>
                */}
                <NavDropdown.Item as={Link} to="/imported-bookings" active={area == 'imported-bookings'} onClick={e => this.onClickNav(e)}>
                    Imported bookings
                </NavDropdown.Item>
                {loginInfo.site.sendInstructorCredentialsEmails &&
                    <NavDropdown.Item onClick={e => this.showInstructorCredentialsEmailsModal()}>
                        Instructor credentials emails
                    </NavDropdown.Item>
                }
                <NavDropdown.Item as={Link} to="/contracts" active={area == 'contracts'} onClick={e => this.onClickNav(e)}>
                    Contracts
                </NavDropdown.Item>

                {/* ============================================================================== */}
                
                <NavDropdown.Header>
                    System setup
                </NavDropdown.Header>
                <NavDropdown.Item as={Link} to="/users" active={area == 'users'} onClick={e => this.onClickNav(e)}>
                    Users
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/courses" active={area == 'courses'} onClick={e => this.onClickNav(e)}>
                    Courses
                </NavDropdown.Item>
                {loginInfo.site.enableSetup &&
                    <NavDropdown.Item as={Link} to="/certs" active={area == 'certs'} onClick={e => this.onClickNav(e)}>
                        Certifications
                    </NavDropdown.Item>
                }
                <NavDropdown.Item as={Link} to="/partners" active={area == 'partners'} onClick={e => this.onClickNav(e)}>
                    Partners
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cost-centres" active={area == 'cost-centres'} onClick={e => this.onClickNav(e)}>
                    Cost centres
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/sub-agencies" active={area == 'sub-agencies'} onClick={e => this.onClickNav(e)}>
                    Sub-agencies
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/referral-codes" active={area == 'referral-codes'} onClick={e => this.onClickNav(e)}>
                    Referral codes
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/contacts" active={area == 'contacts'} onClick={e => this.onClickNav(e)}>
                    Contacts
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/email-types" active={area == 'email-types'} onClick={e => this.onClickNav(e)}>
                    Email notifications
                </NavDropdown.Item>
                {loginInfo.site.enableSetup && <>
                    <NavDropdown.Item as={Link} to="/countries" active={area == 'countries'} onClick={e => this.onClickNav(e)}>
                        Countries
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/help-articles" active={area == 'help-articles'} onClick={e => this.onClickNav(e)}>
                        Help articles
                    </NavDropdown.Item>
                </>}
                <NavDropdown.Item as={Link} to="/tags" active={area == 'tags'} onClick={e => this.onClickNav(e)}>
                    Tags
                </NavDropdown.Item>

                {loginInfo.isSiteAdmin && loginInfo.site.enableDevTasks && <>
                    <NavDropdown.Header>
                        Development
                    </NavDropdown.Header>
                    <NavDropdown.Item as={Link} to="/dev-tasks" active={area == 'dev-tasks'} onClick={e => this.onClickNav(e)}>
                        Development tasks
                    </NavDropdown.Item>
                </>}
            </NavDropdown>
        );
    }
}

export default TopNav;